<template>

  <div>
    <table width="100%">
      <thead>
        <tr>
          <th>
            <my-header h1="Student Profile Summary"></my-header>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <table border="1" width="100%" style="border-collapse: collapse; font-size: 12px">
              <tr>
                <th class="bg" align="left" width="20">Semester:</th>
                <td align="left" width="30">{{Session}}</td>
                <th class="bg" align="left" width="20">Program:</th>
                <td align="left" width="30">{{ProgramName}}</td>
                <th class="bg" align="left" width="20">Gender:</th>
                <td align="left" width="30">{{gender}}</td>
              </tr>
              <tr>
                <th class="bg" align="left" width="20">Disability:</th>
                <td align="left" width="30">{{disability}}</td>
                <th class="bg" align="left" width="20">Resident Of LOC:</th>
                <td align="left" width="30">{{residentOfLOC}}</td>
                <th class="bg" align="left" width="20">Verified:</th>
                <td align="left" width="30">{{verified}}</td>
              </tr>
              <tr>
                <th class="bg" align="left" width="20">City:</th>
                <td align="left" width="30">{{city}}</td>
                <th class="bg" align="left" width="20">District:</th>
                <td align="left" width="30">{{district}}</td>
                <th class="bg" align="left" width="20">Tehsil:</th>
                <td align="left" width="30">{{tehsil}}</td>
              </tr>
            </table>
            <table border="1" width="100%" style="border-collapse:collapse; font-size: 12px; margin-top:10px">
              <thead>
                <tr>
                  <th class="bg">Sr. No.</th>
                  <th class="bg">Program Name</th>
                  <th class="bg">Total Students</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in st">
                  <td align="center">{{ind+1 }}</td>
                  <td>{{item.ProgramName}}</td>
                  <td style="text-align:right">{{item.StudentCount}}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="2" class="bg">Total</th>
                  <th class="bg">{{total}}</th>
                </tr>
              </tfoot>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    props: {
      employeeId: Number,
      sendEmp: Function,
      sendImg: Function,
    },
    data() {
      return {
        st: [],
        Session: '',
        ProgramName: '',
        gender: '',
        city: '',
        disability: '',
        district: '',
        residentOfLOC: '',
        tehsil: '',
        verified: '',
        total: '',
      }
    },

    created: function () {
      this.pageLoad();
    },

    methods: {

      pageLoad() {
        startReq();
        var vm = this;
        axios.get('/api/StudentCardPrintingApi/getProfileSummaryPrint')
          .then(function (res) {
            endReq();
            vm.ProgramName = res.data.progname;
            vm.Session = res.data.ses;
            vm.st = res.data.lst;
            vm.gender = res.data.gender;
            vm.city = res.data.city;
            vm.disability = res.data.disability;
            vm.district = res.data.district;
            vm.residentOfLOC = res.data.residentOfLOC;
            vm.tehsil = res.data.tehsil;
            vm.verified = res.data.verified;
            vm.total = res.data.total;
          })
      },

    }
  })</script>

<style>
  .bg {
    background-color: lightgray;
  }

  .h4-t {
    margin-top: -9px;
    margin-bottom: -5px;
    font-weight: 600
  }

  .h4-c {
    margin-bottom: -5px;
    font-weight: 600
  }
</style>





// WEBPACK FOOTER //
// src/components/cardprinting/studentprofilesummaryprint.vue